<div style="width: auto; overflow: auto">
  <app-common-list-table
          [request]="getRequest"
          [cols]="((canRegister || applicationType === 'cropgest') && appName !== 'manezylozano') ? colsCanRegister : cols"
          [filtering]="filter"
          [showExportCsv]="false"
          [globalVisualTransform]="globalVisualTransform"
          [globalConditionalStyle]="globalConditionalStyle"
          [actionButtonText]="canRegister ? btnAnadir : ''"
          (actionButtonClick)="add()"
          (visualize)="show('info', $event)"
          (edit)="edit($event)"
          (remove)="show('delete', $event)">

    <ng-template #header>
      <button
          type="button"
          class="btn btn-success btn-sm text-white ms-2 fw-bold"
          (click)="downloadCsv()">
        <i class="fa fa-download"></i>
        <span class="ms-1">Exportar a CSV</span>
      </button>
    </ng-template>

    <ng-template #thEnd>
      <th *ngIf="(this.canRegister || this.applicationType === 'cropgest') && this.appName !== 'manezylozano'">
        <p class="mb-0 d-flex justify-content-center">Estado</p>
      </th>
      <th>
        <p class="d-flex justify-content-center"
           style="margin-bottom: 0">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
      <td *ngIf="(this.canRegister || this.applicationType === 'cropgest') && this.appName !== 'manezylozano'">
        <div class="d-flex justify-content-center align-items-center">
            <button [ngStyle]="getStyles('acceso_plataforma', data.data)" 
                class="d-flex justify-content-center align-items-center"
                (click)="toggleActive(data.data)"
                style="
                    height: 20px;
                    width: fit-content;
                    padding: 0 5px;
                    border-radius: 3px;
                    margin-right: 10px;
                    font-weight: bold;
                    cursor: pointer;">
                    {{data.data?.acceso_plataforma === 1 ? 'Activo' : data.data?.acceso_plataforma === 0 ? 'Inactivo' : 'Pendiente'}}
            </button>
        </div>
      </td>
            <td>
                <app-action-buttons
                    [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>
    </ng-template>
  </app-common-list-table>
</div>


<app-modals
    [view]="this"
    [form]="form?.formFields"
    [serverUrl]="serverUrl"
    [previousData]="model"
    [recordHasAssociatedData]="false"
    [getRequest]="getRequest"
    [deleteRequest]="deleteRequest">
</app-modals>

